import { Link } from '@remix-run/react'

export function Logo() {
	return (
		<Link
			to="/"
			aria-label="lamaloot"
			title="lamaloot"
			className="items-baseline space-x-0 md:flex"
		>
			<img
				className="w-auto sm:w-16 md:w-16 lg:w-16"
				src="/img/brand/logo.png"
				alt="LamaLoot logo"
			/>
			<span className="bg-gradient-to-r from-purple-800 to-pink-600 bg-clip-text pb-4 text-3xl font-black tracking-wide text-transparent">
				amaLoot
			</span>
		</Link>
	)
}
